// extracted by mini-css-extract-plugin
export default {"heading":"_2MvF","ibox":"_3Wd8","pageTitle":"_1E3h","chat":"d3Dv","inboxUI":"KUlh","loadingBtn":"_2SH9","minWidthClass":"tLHD"};